import React, { useState, useEffect } from 'react'
import PropTypes from "prop-types"
import _ from 'lodash'
import Moment from 'moment'
import { extendMoment } from 'moment-range';
import  {useTextResources} from '../../../language';


const moment = extendMoment(Moment);

import { Checkbox, Grid } from 'semantic-ui-react'

const weekdays = ["SelectDay_Sun", "SelectDay_Mon", "SelectDay_Tue", "SelectDay_Wed", "SelectDay_Thu", "SelectDay_Fri", "SelectDay_Sat"]
const allDays = [0, 1, 2, 3, 4, 5, 6]
const WeekDaysSelect = ({ onChange, dates, initDays }) => {
    const text = useTextResources()
    const [days, setDays] = useState(initDays || allDays)
    const [daysInRange, setDaysInRange] = useState([])

    useEffect(()=>{
        let datesRange = []
        if (dates) {
            dates.forEach((date)=>{
              if(!date.startDate || !date.endDate) return;
              let range = moment.range(moment(date.startDate).startOf('day'), moment(date.endDate).startOf('day'));
              datesRange.push(...Array.from(range.by("day")).map(d=>d.weekday()))
            })
          }

          datesRange = _.uniq(datesRange);
          const isWholeWeek = _.xor(allDays.map(day => day + 1), datesRange).length;
          setDaysInRange(datesRange);
          
          if (isWholeWeek) {
            setDays(datesRange);
            onChange?.(datesRange);
          }
    }, [dates])

    const handleWeekdayCheck = (index, checked) => {
        const newDays = checked ? _.union(days, [index]) : _.xor(days, [index])
        setDays(newDays)
        onChange && onChange(newDays)
    }

    const handleAllCheck = (checked) => {
        const newDays = checked ? allDays : []
        setDays(newDays);
        onChange && onChange(newDays)
    }

    return (
        <Grid textAlign="center" columns='equal'>
            {
                _.map(weekdays, (weekday, index) => {
                    return (
                        <Grid.Column key={weekday}>
                            <div>{text(weekday)}</div>
                            <Checkbox checked={_.includes(days, index)} disabled={!_.includes(daysInRange, index)} onChange={(e, { checked }) => handleWeekdayCheck(index, checked)}></Checkbox>
                        </Grid.Column>
                    )
                })
            }
            <Grid.Column>
                <div>{text("All")}</div>
                <Checkbox checked={_.isEmpty(_.xor(allDays, days))} disabled={daysInRange.length < 7} onChange={(e, { checked }) => handleAllCheck(checked)}></Checkbox>
            </Grid.Column>
        </Grid>
    )
}
WeekDaysSelect.propTypes = {
    onChange: PropTypes.func,
    dates: PropTypes.array,
    initDays: PropTypes.array
}
export default WeekDaysSelect